import React, { useEffect, useRef, useState } from 'react';
import Linkify from 'linkify-react';

import { splitEmotes } from '../../emotes';

const LINKIFY = { target: '_blank', rel: 'noopener noreferrer' };

// A message with its emotes as images; links are made clickable unless told otherwise
export const EmoteText = ({ content, emotes, linkify = true }) =>
  splitEmotes(content, emotes).map((part, index) =>
    part.emote ? (
      <img key={index} className='emote' src={part.emote.url} alt={`:${part.emote.code}:`} title={part.emote.code} loading='lazy' />
    ) : linkify ? (
      <Linkify key={index} options={LINKIFY}>
        {part.text}
      </Linkify>
    ) : (
      <React.Fragment key={index}>{part.text}</React.Fragment>
    )
  );

// The button next to the composer that opens the grid of emotes; picking one closes it
export const EmotePicker = ({ emotes, disabled, onPick }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // A tap anywhere else closes it
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (!ref.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  if (!emotes.length) return null;

  return (
    <div className='picker' ref={ref}>
      <button
        type='button'
        className='picker__toggle'
        aria-label='Emotes'
        aria-expanded={open}
        disabled={disabled}
        onClick={() => setOpen((value) => !value)}
      >
        🙂
      </button>
      {open && (
        <div className='picker__grid' role='listbox' aria-label='Emotes del evento'>
          {emotes.map((emote) => (
            <button
              key={emote.code}
              type='button'
              className='picker__emote'
              role='option'
              aria-selected={false}
              title={`:${emote.code}:`}
              onClick={() => {
                onPick(emote.code);
                setOpen(false);
              }}
            >
              <img src={emote.url} alt={emote.code} loading='lazy' />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
